module.exports = __webpack_public_path__ + "static/media/helically_formed_dead_end_grip.8e294b99.webp";